import { Layers, Monitor } from 'lucide-react'
import type { AppModule } from '@/shared/modules'

export const MODEL_TRAINING_MODULE_ID = 'model-training'

export const modelTrainingModule: AppModule = {
  id: MODEL_TRAINING_MODULE_ID,
  surface: 'app',
  permissions: ['model-training:view'],
  nav: [
    {
      to: '/app/model-training',
      labelKey: 'nav.modelTraining',
      icon: Monitor,
      group: { id: 'model-management', labelKey: 'nav.modelManagement', icon: Layers },
    },
  ],
}
